<template>
  <sc-page-base :loading="loading">
    <div class="columns">
      <div class="column is-12">
        <sc-steps v-model="activeStep" size="is-medium" :has-navigation="false">

          <sc-step-item
            v-for="(step, index) in steps"
            :key="index"
            :label="step.title"
            :step="index + 1"
            :clickable="false"
          >
            <component :is="step.component" :schemaBased="step" :isEdit="false" />
          </sc-step-item>

        </sc-steps>
      </div>
    </div>
  </sc-page-base>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import {
  ScSteps,
  ScStepItem,
  ScPageBase,
} from '@intelipost-js/secure-components';

import ScCredentials from '../sc-credentials/ScCredentials.vue';
import ScConfigSysnode from '../sc-config-sysnode/ScConfigSysnode';
import ScContact from '../sc-contact/ScContact';
import ScDataCarrier from '../sc-data-carrier/ScDataCarrier';
import ScTest from '../sc-test/ScTest';
import ScFinished from '../sc-finished/ScFinished';
import ScReids from '../sc-reids/ScReids';

const { mapState, mapMutations, mapActions } = createNamespacedHelpers(
  'integrations/integrationsStep',
);

export default {
  name: 'sc-step',
  data() {
    return {
      details: null,
      steps: [],
      schemaBased: {
        steps: [],
      },
    };
  },
  computed: {
    ...mapState(['activeStep', 'loading', 'appDetails']),
  },
  created() {
    this.getAppAndMountSteps();
  },
  methods: {
    ...mapActions(['getAppAndInstalation', 'getCredentials']),
    ...mapMutations(['setActiveStep', 'toggleLoading']),

    getComponentForStep(step) {
      const componentMap = {
        1: ScCredentials,
        2: ScReids,
      };
      return componentMap[step.stepNumber] || ScTest;
    },

    async getAppAndMountSteps() {
      this.schemaBased = JSON.parse(this.appDetails.app.schemaBased);
      const dynamicSteps = this.schemaBased.steps.map(step => ({
        ...step,
        component: this.getComponentForStep(step),
      }));

      this.steps = [
        ...dynamicSteps,
        { title: 'Configurações de envio', component: ScConfigSysnode },
        { title: 'Contatos', component: ScContact },
        { title: 'Credenciais na Intelipost', component: ScDataCarrier },
        { title: 'Concluído', component: ScFinished },
      ];

      if (this.appDetails.installation.status === 'INSTALLED') {
        const APP_ID = this.$route.params.id;
        this.setActiveStep(this.steps.length - 2);
        this.toggleLoading(true);
        await this.getCredentials(APP_ID);
        this.toggleLoading(false);
      }
    },
  },
  components: {
    ScSteps,
    ScStepItem,
    ScCredentials,
    ScConfigSysnode,
    ScContact,
    ScDataCarrier,
    ScTest,
    ScFinished,
    ScPageBase,
    ScReids,
  },
};
</script>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-integrations/features/integrations-app-v2/components/sc-step/ScStep.vue?404f936e